var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconPassenger = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18 7.125C18 10.2315 15.4815 12.75 12.375 12.75C9.2685 12.75 6.75 10.2315 6.75 7.125C6.75 4.0185 9.2685 1.5 12.375 1.5C15.4815 1.5 18 4.0185 18 7.125ZM16.5 7.125C16.5 4.8465 14.6535 3 12.375 3C10.0965 3 8.25 4.8465 8.25 7.125C8.25 9.4035 10.0965 11.25 12.375 11.25C14.6535 11.25 16.5 9.4035 16.5 7.125Z", fill: "black" }),
            React.createElement("path", { d: "M6.75 21.75V16.1318C6.75 14.6715 7.9635 13.5 9.45 13.5H15.3C16.7865 13.5 18 14.6715 18 16.1318V21.75C18 22.164 17.664 22.5 17.25 22.5H7.5C7.086 22.5 6.75 22.164 6.75 21.75ZM16.5 16.1318C16.5 15.5123 15.9697 15 15.3 15H9.45C8.78025 15 8.25 15.5123 8.25 16.1318V21H16.5V16.1318Z", fill: "black" }))),
        alt: 'Icon Passenger',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconPassenger;
//# sourceMappingURL=index.js.map